var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_4353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66667 13.1667V9.16667H11.3333V13.1667H12.6667V5.71867L10.7813 3.83333H3.33333V13.1667H4.66667ZM2.66667 2.5H11.3333L14 5.16667V13.8333C14 14.0101 13.9298 14.1797 13.8047 14.3047C13.6797 14.4298 13.5101 14.5 13.3333 14.5H2.66667C2.48986 14.5 2.32029 14.4298 2.19526 14.3047C2.07024 14.1797 2 14.0101 2 13.8333V3.16667C2 2.98986 2.07024 2.82029 2.19526 2.69526C2.32029 2.57024 2.48986 2.5 2.66667 2.5ZM6 10.5V13.1667H10V10.5H6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameIcon);
export default __webpack_public_path__ + "static/media/frame-icon.029fd2f796d7775ee4aef26f2d7ddbe3.svg";
export { ForwardRef as ReactComponent };